import { rest } from 'utils';
import { featuresToggle } from 'utils/features-toggle';
import { sampleData } from '../constant/sample-data';

export default {
  registry: {
    getAll: () => (featuresToggle.isSampleData() ? (
      new Promise((resolve) => resolve(sampleData.containerRegistry.getAllRegistries))
    ) : (
      rest.get({ baseUrl: 'containerRegistry', url: '/registries' })
    )),

    create: ({ properties }) => (featuresToggle.isSampleData() ? (
      new Promise((resolve) => { console.log('create registry', { properties }); return resolve({}); })
    ) : (
      rest.post({ baseUrl: 'containerRegistry', url: '/registries', body: { properties } })
    )),

    get: ({ id }) => (featuresToggle.isSampleData() ? (
      new Promise((resolve) => resolve(sampleData.containerRegistry.getRegistry))
    ) : (
      rest.get({ baseUrl: 'containerRegistry', url: `/registries/${id}` })
    )),

    checkNameAvailability: ({ name }) => (featuresToggle.isSampleData() ? (
      new Promise((resolve) => resolve({}))
    ) : (
      rest.head({ baseUrl: 'containerRegistry', url: `/names/${name}` })
    )),

    delete: ({ id }) => (featuresToggle.isSampleData() ? (
      new Promise((resolve) => { console.log('delete registry', { id }); return resolve({}); })
    ) : (
      rest.delete({ baseUrl: 'containerRegistry', url: `/registries/${id}` })
    )),

    update: ({ properties, id }) => (featuresToggle.isSampleData() ? (
      new Promise((resolve) => { console.log('Update Registry: ', properties); return resolve({}); })
    ) : (
      rest.patch({ baseUrl: 'containerRegistry', url: `/registries/${id}`, body: properties })
    )),

    getV2: ({ id, appendToEndOfUrl = '' }) => (featuresToggle.isSampleData() ? (
      new Promise((resolve) => resolve(sampleData.containerRegistry.getRegistry))
    ) : (
      rest.get({ baseUrl: 'containerRegistry', url: `/registries/${id}/v2${appendToEndOfUrl}` })
    )),
  },
  token: {
    getAll: ({ registryId }) => (featuresToggle.isSampleData() ? (
      new Promise((resolve) => resolve(sampleData.containerRegistry.getAllTokens))
    ) : (
      rest.get({ baseUrl: 'containerRegistry', url: `/registries/${registryId}/tokens` })
    )),

    create: ({ registryId, properties }) => (featuresToggle.isSampleData() ? (
      new Promise((resolve) => { console.log('Create Token: ', { properties }); return resolve(sampleData.containerRegistry.getToken); })
    ) : (
      rest.post({ baseUrl: 'containerRegistry', url: `/registries/${registryId}/tokens`, body: { properties } })
    )),

    get: ({ registryId, tokenId }) => (featuresToggle.isSampleData() ? (
      new Promise((resolve) => resolve(sampleData.containerRegistry.getToken))
    ) : (
      rest.get({ baseUrl: 'containerRegistry', url: `/registries/${registryId}/tokens/${tokenId}` })
    )),

    update: ({ registryId, tokenId, properties }) => (featuresToggle.isSampleData() ? (
      new Promise((resolve) => { console.log('update Token: ', properties); return resolve({}); })
    ) : (
      rest.patch({ baseUrl: 'containerRegistry', url: `/registries/${registryId}/tokens/${tokenId}`, body: properties })
    )),

    delete: ({ registryId, tokenId }) => (featuresToggle.isSampleData() ? (
      new Promise((resolve) => { console.log('Delete Token: ', { registryId, tokenId }); return resolve({}); })
    ) : (
      rest.delete({ baseUrl: 'containerRegistry', url: `/registries/${registryId}/tokens/${tokenId}` })
    )),
  },
  repository: {
    getAll: ({ registryId }) => (featuresToggle.isSampleData() ? (
      new Promise((resolve) => resolve(sampleData.containerRegistry.getAllRepositories))
    ) : (
      rest.get({ baseUrl: 'containerRegistry', url: `/registries/${registryId}/v2/_catalog` })
    )),

    get: ({ registryId, repoName }) => (featuresToggle.isSampleData() ? (
      new Promise((resolve) => resolve(sampleData.containerRegistry.getRepository))
    ) : (
      rest.get({ baseUrl: 'containerRegistry', url: `/registries/${registryId}/v2/${repoName}/tags/list` })
    )),

    getTags: ({ registryId, repoName }) => (featuresToggle.isSampleData() ? (
      new Promise((resolve) => setTimeout(() => resolve(sampleData.containerRegistry.getRepositoryTags), 3000))
    ) : (
      rest.get({ baseUrl: 'containerRegistry', url: `/registries/${registryId}/v2/${repoName}/tags/list` })
    )),

    delete: ({ registryId, repoName }) => (featuresToggle.isSampleData() ? (
      new Promise((resolve) => { console.log('Delete Token: ', { registryId, repoName }); return resolve({}); })
    ) : (
      rest.delete({ baseUrl: 'containerRegistry', url: `/registries/${registryId}/repositories/${repoName}` })
    )),

    getManifest: ({ registryId, repoName, tagName }) => (featuresToggle.isSampleData() ? (
      new Promise((resolve) => resolve(sampleData.containerRegistry.getRepositoryManifest))
    ) : (
      rest.get({ baseUrl: 'containerRegistry', url: `/registries/${registryId}/v2/${repoName}/manifests/${tagName}` })
    )),
  },

  location: {
    getAll: () => (featuresToggle.isSampleData() ? (
      new Promise((resolve) => resolve(sampleData.containerRegistry.getLocations))
    ) : (
      rest.get({ baseUrl: 'containerRegistry', url: '/locations' })
    )),
  },
};

// create new regstry
// ---------------------
// {
//   "garbageCollectionSchedule": {
//     "days": ["Sunday"], // [ Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, Saturday ]
//     "time": "01:23:00+00:00"
//   },
//   "location": "DE",
//   "maintenanceWindow": {
//     "days": ["Sunday"], // [ Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, Saturday ]
//     "time": "01:23:00+00:00"
//   },
//   "name": "string"
// }

// update registry
// ---------------------
// {
//   "garbageCollectionSchedule": {
//     "days": [
//       "Sunday"
//     ],
//     "time": "01:23:00+00:00"
//   },
//   "maintenanceWindow": {
//     "days": [
//       "Sunday"
//     ],
//     "time": "01:23:00+00:00"
//   }
// }

// Create token
// ---------------------
// {
//   "expiryDate": "2022-05-03T10:35:52.076Z",
//   "name": "string",
//   "scopes": [
//     {
//       "actions": [
//         "string"
//       ],
//       "name": "string",
//       "type": "string"
//     }
//   ],
//   "status": "enabled"
// }

// Update token
// ---------------------
// {
//   "expiryDate": "2022-05-03T10:41:15.061Z",
//   "scopes": [
//     {
//       "actions": [
//         "string"
//       ],
//       "name": "string",
//       "type": "string"
//     }
//   ],
//   "status": "enabled"
// }
